import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import CustomButton from "../pages/custombutton";
import { LuNewspaper } from "react-icons/lu";
import { GrCompliance } from "react-icons/gr";
import { FcAbout } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import { FaBriefcase } from "react-icons/fa";
import { IoMdInformationCircle } from "react-icons/io";
import { GrAnnounce } from "react-icons/gr";
import { GoGraph } from "react-icons/go";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FaFileAlt } from "react-icons/fa";
import { HiOutlineCurrencyDollar } from "react-icons/hi2";

const MegaMenu = ({ openMenu, menuType, isOpen }) => {

  const [selectedCategory, setSelectedCategory] = useState("Sales");
  function truncateText(text, wordLimit = 15) {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  }

  if (openMenu !== menuType) {
    return null;
  }

  return (
    <div>
      {openMenu === "products" && (
        <div className="absolute left-0 top-full max-w-screen w-full bg-white shadow-lg border-t">
          <div className="flex max-w-full w-full mx-auto px-4 py-8">
            {/* Left Sidebar */}
            {/*
            <div className="w-1/4 border-r pr-6" style={{ overflowY: "scroll", height: "70vh" }}>
              <div className="relative w-full max-w-md text-xs font-normal mb-6">
                <input
                  className="w-full py-2 pl-10 pr-4 border rounded-sm focus:outline-none focus:ring-1 focus:[#7453E0]"
                  type="text"
                  placeholder="I’m looking for…"
                  autoComplete="off"
                />
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <FaSearch />
                </div>
              </div>
              <h3 className="text-base font-normal">Categories</h3>
              <ul className="mt-4 space-y-2">
                <li
                  className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Sales")}
                  onMouseEnter={() => setSelectedCategory("Sales")}
                >
                  <div className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300">
                    <span>Sales</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Marketing")}
                  onMouseEnter={() => setSelectedCategory("Marketing")}>
                  <div className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300">
                    <span>D2C/Marketplace</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Commerce-And-POS")}
                  onMouseEnter={() => setSelectedCategory("Commerce-And-POS")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Retail</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Service")}
                  onMouseEnter={() => setSelectedCategory("Service")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Warehouse</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Finance")}
                  onMouseEnter={() => setSelectedCategory("Finance")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Logistics</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Finance")}
                  onMouseEnter={() => setSelectedCategory("Finance")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>B2B</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Finance")}
                  onMouseEnter={() => setSelectedCategory("Finance")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Marketing</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>

                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Finance")}
                  onMouseEnter={() => setSelectedCategory("Finance")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Compliance</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>
                <li className="group hover:text-[#7453E0]"
                  onClick={() => setSelectedCategory("Finance")}
                  onMouseEnter={() => setSelectedCategory("Finance")}>
                  <div
                    className="flex items-center justify-between hover:bg-slate-100 font-normal text-sm py-2 pl-2 pr-8 transition-all duration-300"
                  >
                    <span>Analytics</span>
                    <MdOutlineChevronRight className="transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </li>
              </ul>
              {/* <div className="flex justify-start mt-8 w-full">
                <Link to="/products" className="w-full">
                  <button className="bg-[#7453E0] text-white font-semibold px-4 py-2 rounded-sm flex items-center justify-center w-full gap-2">
                    Explore All Products
                    <MdOutlineChevronRight />
                  </button>
                </Link>
              <CustomButton to="/products" label="Explore All Products" />
            </div>

            {/* Right Side - Product Grid */}
            <div className="w-full pl-6">
              {selectedCategory === "Sales" ?
                <div>
                  <h3 className="text-xl font-normal"></h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-4 justify-items-center">
                    <Link className="bg-white p-3 shadow-md rounded-lg text-center w-full max-w-xs hover:scale-105 transition-transform" to="/products/sales/inficonnect">
                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">InfiConnect</h4>
                          <img
                            src="/inficonnectLogoPrevious.png"
                            alt="Product Catalog Illustration"
                            className="w-8 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "Turn Customer Data into Real-World Footfall."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/zeroclik">
                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">

                          <h4 className="text-lg font-normal">Zero Clik</h4>
                          <img
                            src="/zeroclickLogo.svg"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "Launch a Business in Minutes, Run it Like an Enterprise."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/xpressbazaar">
                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">

                          <h4 className="text-lg font-normal">Xpress Baazaar</h4>
                          <img
                            src="/expressbazaarLogo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "Your one-stop online marketplace offering a wide range of products from trusted vendors."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/qwikco">

                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">Qwikco</h4>
                          <img
                            src="/qwikcoLogo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "A comprehensive platform for connecting vendors and brands, empowering partnership and loyalty management."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/connect-plus">

                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">Connect Plus</h4>
                          <img
                            src="/connectPlus/logo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "Connect plus is a no-code conversational AI workflow management platform designed to empower businesses with real-time bot customization. This console enables non-technical users to design, modify, and optimize chatbot workflows without writing a single line of code."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/chatbot">

                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">VIBE</h4>
                          <img
                            src="/victor/logo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "VIBE is a WhatsApp chatbot for political campaigning. It will enable direct engagement with voters, raise awareness about the politician’s achievements, and gather actionable insights on voter sentiment to support strategic decision-making during the election campaign."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/genius">
                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">Genius</h4>
                          <img
                            src="/genius/logo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "Genius is a powerful, AI-driven analytics and optimization suite by ENS Enterprises, purpose-built to empower D2C brands and digital-first businesses."
                          )}
                        </p>
                      </div>
                    </Link>
                    <Link className="bg-white p-3 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] md:rounded-lg text-center mx-4 md:mx-0 cursor-pointer hover:scale-105 transition-transform transform" to="/products/sales/shop-sense">
                      <div className="p-4 rounded">
                        <div className="flex justify-between items-center mb-2">
                          <h4 className="text-lg font-normal">Shop Sense</h4>
                          <img
                            src="/shopSense/logo.png"
                            alt="Product Catalog Illustration"
                            className="w-auto h-10 rounded-lg"
                          />
                        </div>
                        <p className="text-xs font-light lg:min-h-16">
                          {truncateText(
                            "ShopSense AI by by ENS Enterprises is a comprehensive, AI-powered conversational commerce solution designed for retail and e-commerce businesses."
                          )}
                        </p>
                      </div>
                    </Link>

                  </div>
                </div>
                : <div>
                  <p>Coming Soon ...</p>
                </div>}
            </div>
          </div>
        </div>
      )}

      <div className="relative">
        {openMenu === "company" && (
          <div className="absolute flex bg-white shadow-lg p-6 z-50 w-[600px] rounded-lg" style={{marginTop: "30px"}}>
            {/* Left Column */}
            <div className="w-1/2 pr-8 ">
              <div className="space-y-4">
                <div className="flex items-center space-x-2 text-sm">
                  <span className="text-lg"><IoMdInformationCircle /></span>
                  <span className="font-normal">About Us</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <span className="text-lg"><FaBriefcase /></span>
                  <span className="font-normal">Careers</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <span className="text-lg"><LuNewspaper /></span>
                  <span className="font-normal">News</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <span className="text-lg"><FaFacebook /></span>
                  <span className="font-normal">Social Media</span>
                </div>
                <div className="flex items-center space-x-2 text-sm">
                  <span className="text-lg"><GrCompliance /></span>
                  <span className="font-normal">Compliance</span>
                </div>
              </div>

            </div>

            {/* Right Column */}
            <div className="w-1/2 pl-8 hidden">
              <h4 className="text-blue-600 font-semibold text-sm tracking-widest uppercase mb-4">
                Some Content Here
              </h4>
            </div>
          </div>
        )}
      </div>

      <div className="relative">
        {openMenu === "Investors" && (
          <div className="absolute bg-white shadow-lg p-4 z-50 flex flex-col rounded-lg gap-4" style={{marginTop: "30px"}}>
            <div className="flex items-center space-x-2 text-sm">
              <span className="text-lg"><FaFileAlt /></span>
              <span className="font-normal">Pitch Deck</span>
            </div>

            <div className="flex items-center space-x-2 text-sm">
              <span className="text-lg"><GoGraph /></span>
              <span className="font-normal">Annual Reports</span>
            </div>

            <div className="flex items-center space-x-2 text-sm">
              <span className="text-lg"><HiOutlineCurrencyDollar /></span>
              <span className="font-normal">Financial Results</span>
            </div>

            <div className="flex items-center space-x-2 text-sm">
              <span className="text-lg"><GrAnnounce  /></span>
              <span className="font-normal">Announcements</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;
